// /* eslint-disable jsx-a11y/img-redundant-alt */
// import React, { useEffect, useState } from "react";
// import Navbar from "../Components/Navbar";
// import useDisableCopy from "../Components/useDisableCopy";
// import Instructions from "../exams/Instructions";
// import { message } from "antd";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   Container,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Typography,
// } from "@mui/material";
// import axios from "../axiosInstance";
// import { Box } from "@mui/material";
// import { ListItemText } from "@mui/material";
// import "./WriteExam.css";
// import { Modal } from "antd";

// const WriteExam = () => {
//   useDisableCopy();
//   const studentData = JSON.parse(localStorage.getItem("verifiedStudent"));
//   const params = useParams();
//   const [examData, setExamData] = useState(null);
//   const [questions, setQuestions] = useState([]);
//   const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(0);
//   const [selectedOptions, setSelectedOptions] = useState([]);
//   const [result, setResult] = useState({});
//   const navigate = useNavigate();
//   const [view, setView] = useState("instructions");
//   const [timeLeft, setTimeLeft] = useState({ minutes: 0, seconds: 0 });
//   const [timeUp, setTimeUp] = useState(false);
//   const [intervalId, setIntervalId] = useState(null);
//   const [examStarted, setExamStarted] = useState(false);
//   const [startTime, setStartTime] = useState(null);
//   const [isModalVisible, setIsModalVisible] = useState(false);

//   // Handle the modal visibility
//   const showModal = () => {
//     setIsModalVisible(true);
//   };

//   const handleOk = () => {
//     clearInterval(intervalId);
//     setTimeUp(true);
//     localStorage.removeItem(`timer-${params.id}`);
//     setIsModalVisible(false);
//   };

//   const handleCancel = () => {
//     setIsModalVisible(false);
//   };

//   // Transform API question data to component format
//   const transformQuestions = (apiQuestions) => {
//     return apiQuestions.map((q) => {
//       console.log("Question Data:", q);
//       console.log("Options:", q.options);
//       console.log("Correct Options:", q.correctOption);
//       // Extract text and images from questionText
//       const questionContent = [];
//       if (q.questionText) {
//         questionContent.push({
//           type: "text",
//           content: q.questionText,
//         });
//       }
//       if (q.questionImage && q.questionImage !== "") {
//         questionContent.push({
//           type: "image",
//           content: q.questionImage,
//         });
//       }

//       // Transform options
//       const options = q.options.map((opt, idx) => ({
//         text: opt.text || "",
//         images: opt.image && opt.image !== "" ? [opt.image] : [],
//       }));

//       // Get correct option indices - store as NUMBERS for easy comparison
//       // const correctOptionIndices = q.correctOptions.map((opt) =>
//       //   typeof opt === "object" ? opt.optionIndex : opt,
//       // );

//       const correctOptionIndices = (q.correctOptions || []).map((opt) =>
//         typeof opt === "object" ? opt.optionIndex : opt,
//       );

//       return {
//         _id: q._id,
//         name: questionContent,
//         options: options,
//         correctOption: correctOptionIndices,
//         correctOptionTexts: q.correctOptions, // Store original for backend
//         questionType: q.questionType,
//         marks: q.marks || 1,
//       };
//     });
//   };

//   // Fetch exam data
//   const getExamData = async () => {
//     try {
//       const response = await axios.get(`/api/v1/exam/attempt/${params?.id}`);

//       // console.log(response.data.data, "exam data")

//       if (response.data.success && response.data.data) {
//         const apiData = response.data.data;

//         // Transform questions to expected format
//         const transformedQuestions = transformQuestions(
//           apiData.questions || [],
//         );

//         setQuestions(transformedQuestions);
//         setExamData({
//           ...apiData,
//           questions: transformedQuestions,
//           totalMarks: apiData.totalMarks,
//           duration: apiData.duration,
//           passingMarks: apiData.passingMarks,
//           negativeMarking: apiData.negativeMarking,
//           name: apiData.name,
//           subject: apiData.subject,
//           class: apiData.class,
//           examSet: apiData.examSet || "Set 1",
//           category: apiData.subject || "General",
//           instituteCourseId: apiData.class || "",
//         });

//         const savedTime = JSON.parse(
//           localStorage.getItem(`timer-${params.id}`),
//         );
//         if (savedTime) {
//           setTimeLeft(savedTime);
//         } else {
//           setTimeLeft({
//             minutes: Math.floor(apiData.duration || 0),
//             seconds: 0,
//           });
//         }

//         // Initialize selectedOptions array
//         setSelectedOptions(new Array(transformedQuestions.length).fill({}));
//       }
//     } catch (error) {
//       // console.log("FULL ERROR:", error);
//       // console.log("ERROR RESPONSE:", error.response);
//       // console.log("ERROR MESSAGE:", error.message);
//       message.error(
//         error.response?.data?.message || "Failed to fetch exam data",
//       );
//     }
//   };

//   // Function to handle checkbox changes based on user selection
//   const handleCheckboxChange = (optionIndex) => {
//     const currentQuestion = questions[selectedQuestionIndex];
//     const isSingleSelect =
//       currentQuestion?.questionType === "single" ||
//       currentQuestion?.correctOption?.length === 1;

//     setSelectedOptions((prev) => {
//       const updated = [...prev];
//       const currentSelected = updated[selectedQuestionIndex] || {};

//       if (isSingleSelect) {
//         // For single select, only one option can be selected
//         const newSelected = {};
//         newSelected[optionIndex] = !currentSelected[optionIndex];
//         updated[selectedQuestionIndex] = newSelected;
//       } else {
//         // For multi-select, toggle the selected option
//         updated[selectedQuestionIndex] = {
//           ...currentSelected,
//           [optionIndex]: !currentSelected[optionIndex],
//         };
//       }

//       return updated;
//     });
//   };

//   // Calculate time taken
//   const calculateTimeTaken = () => {
//     if (startTime) {
//       const endTime = new Date();
//       const timeDiff = Math.floor((endTime - startTime) / 1000);
//       return timeDiff;
//     }
//     return 0;
//   };

//   // Prepare answers array for API - SEND IN BOTH FORMATS TO SATISFY BACKEND
//   // const prepareAnswersArray = () => {
//   //   const answers = [];

//   //   questions.forEach((question, index) => {
//   //     const selected = selectedOptions[index];
//   //     const selectedOptionsList = [];

//   //     if (selected) {
//   //       Object.keys(selected).forEach((key) => {
//   //         if (selected[key]) {
//   //           // Send as object with optionIndex and text (as your backend expects from the exam fetch response)
//   //           const optionText = question.options[parseInt(key)]?.text || "";
//   //           selectedOptionsList.push({
//   //             optionIndex: parseInt(key),
//   //             text: optionText
//   //           });
//   //         }
//   //       });
//   //     }

//   //     answers.push({
//   //       questionId: question._id,
//   //       selectedOptions: selectedOptionsList,
//   //     });
//   //   });

//   //   return answers;
//   // };

//   const prepareAnswersArray = () => {
//     const answers = [];

//     questions.forEach((question, index) => {
//       const selected = selectedOptions[index];

//       let selectedOptionsList = [];

//       if (selected) {
//         selectedOptionsList = Object.keys(selected)
//           .filter((key) => selected[key])
//           .map((key) => Number(key)); // IMPORTANT
//       }

//       answers.push({
//         questionId: question._id,
//         selectedOptions: selectedOptionsList,
//       });
//     });

//     return answers;
//   };

//   // Calculate Exam Result and Submit to API
//   const calculateResult = async () => {
//     try {
//       const timeTaken = calculateTimeTaken();
//       const answers = prepareAnswersArray();

//       const studentClass = examData?.class || "Not Specified";
//       const studentName =
//         studentData?.studentName || studentData?.name || "Student";

//       const requestBody = {
//         examId: params?.id,
//         studentId: studentData?._id,
//         studentName: studentName,
//         studentClass: studentClass,
//         timeTaken: timeTaken,
//         answers: answers,
//       };

//       // console.log("Submitting exam:", JSON.stringify(requestBody, null, 2));

//       const response = await axios.post(`/api/v1/report/submit`, requestBody);

//       if (response.data.success) {
//         setResult({
//           verdict: response.data.data.verdict,
//           totalMarks: response.data.data.totalMarks,
//           obtainedMarks: response.data.data.obtainedMarks,
//           correctAnswers: response.data.data.correctAnswers,
//           wrongAnswers: response.data.data.wrongAnswers,
//           skippedAnswers: response.data.data.skippedAnswers,
//           negativeMarks: response.data.data.negativeMarks,
//           percentage: response.data.data.percentage,
//           timeTaken: response.data.data.timeTaken,
//         });
//         setView("result");
//         message.success(response.data.message);
//       } else {
//         message.error(response.data.message);
//         calculateLocalResult();
//       }
//     } catch (error) {
//       console.error("Submit exam error:", error);
//       message.error(error.response?.data?.message || "Failed to submit exam");
//       calculateLocalResult();
//     }
//   };

//   // Local calculation that actually works based on your correct answers
//   const calculateLocalResult = () => {
//     let correctAnswers = 0;
//     let wrongAnswers = 0;
//     let skippedAnswers = 0;
//     let obtainedMarks = 0;
//     let negativeMarksTotal = 0;
//     const negativeMarking = examData?.negativeMarking || 0;

//     console.log("Calculating local result...");
//     console.log("Questions:", questions);
//     console.log("Selected Options:", selectedOptions);

//     questions.forEach((question, index) => {
//       const selected = selectedOptions[index];
//       const questionMarks = question.marks || 1;

//       console.log(`Question ${index + 1}:`, {
//         selected,
//         correctOption: question.correctOption,
//         marks: questionMarks,
//       });

//       if (
//         !selected ||
//         Object.keys(selected).length === 0 ||
//         Object.values(selected).every((v) => v === false)
//       ) {
//         skippedAnswers++;
//         console.log(`Question ${index + 1}: Skipped`);
//         return;
//       }

//       const selectedOptionsIndexes = Object.keys(selected)
//         .filter((key) => selected[key])
//         .map((key) => parseInt(key))
//         .sort((a, b) => a - b);

//       const correctOptionsIndices = [...question.correctOption].sort(
//         (a, b) => a - b,
//       );

//       console.log(`Question ${index + 1}:`, {
//         selectedIndices: selectedOptionsIndexes,
//         correctIndices: correctOptionsIndices,
//         isEqual:
//           JSON.stringify(selectedOptionsIndexes) ===
//           JSON.stringify(correctOptionsIndices),
//       });

//       const isCorrect =
//         JSON.stringify(selectedOptionsIndexes) ===
//         JSON.stringify(correctOptionsIndices);

//       if (isCorrect) {
//         correctAnswers++;
//         obtainedMarks += questionMarks;
//         console.log(`Question ${index + 1}: CORRECT, +${questionMarks} marks`);
//       } else {
//         wrongAnswers++;
//         if (negativeMarking > 0) {
//           const deduction = negativeMarking;
//           negativeMarksTotal += deduction;
//           obtainedMarks -= deduction;
//         }
//         console.log(`Question ${index + 1}: WRONG`);
//       }
//     });

//     obtainedMarks = Math.max(0, obtainedMarks);
//     const percentage = (obtainedMarks / examData.totalMarks) * 100;
//     let verdict = "Fail";
//     if (obtainedMarks >= examData.passingMarks) {
//       verdict = "Pass";
//     }

//     console.log("Final Result:", {
//       correctAnswers,
//       wrongAnswers,
//       skippedAnswers,
//       obtainedMarks,
//       totalMarks: examData.totalMarks,
//       percentage,
//       verdict,
//     });

//     setResult({
//       correctAnswers,
//       wrongAnswers,
//       skippedAnswers,
//       verdict,
//       totalMarks: examData.totalMarks,
//       obtainedMarks: obtainedMarks.toFixed(2),
//       percentage: percentage.toFixed(2),
//       negativeMarks: negativeMarksTotal,
//       timeTaken: calculateTimeTaken(),
//     });
//     setView("result");
//   };

//   // Start Timer Function
//   const startTimer = () => {
//     let totalSeconds = timeLeft.minutes * 60 + timeLeft.seconds;
//     const intervalId = setInterval(() => {
//       if (totalSeconds > 0) {
//         const minutes = Math.floor(totalSeconds / 60);
//         const seconds = totalSeconds % 60;
//         setTimeLeft({ minutes, seconds });
//         localStorage.setItem(
//           `timer-${params.id}`,
//           JSON.stringify({ minutes, seconds }),
//         );
//         totalSeconds--;
//       } else {
//         clearInterval(intervalId);
//         setTimeUp(true);
//       }
//     }, 1000);
//     setIntervalId(intervalId);
//   };

//   useEffect(() => {
//     if (timeUp && view === "questions") {
//       clearInterval(intervalId);
//       calculateResult();
//       localStorage.removeItem(`timer-${params.id}`);
//     }
//   }, [timeUp]);

//   useEffect(() => {
//     if (params.id) {
//       getExamData();
//     }
//   }, [params.id]);

//   useEffect(() => {
//     return () => {
//       if (intervalId) {
//         clearInterval(intervalId);
//       }
//       if (view !== "result") {
//         localStorage.removeItem("selectedOptions");
//         localStorage.removeItem("selectedQuestionIndex");
//         localStorage.removeItem("timeLeft");
//         localStorage.removeItem(`timer-${params.id}`);
//         exitFullScreen();
//         setExamStarted(false);
//       }
//     };
//   }, [params.id, intervalId, view]);

//   const requestFullScreen = (element) => {
//     if (element?.requestFullscreen) {
//       element?.requestFullscreen();
//     } else if (element?.mozRequestFullScreen) {
//       element?.mozRequestFullScreen();
//     } else if (element?.webkitRequestFullscreen) {
//       element?.webkitRequestFullscreen();
//     } else if (element?.msRequestFullscreen) {
//       element?.msRequestFullscreen();
//     }
//   };

//   const handleStartExam = () => {
//     setView("questions");
//     requestFullScreen(document?.documentElement);
//     setStartTime(new Date());
//     startTimer();
//     setExamStarted(true);
//   };

//   const exitFullScreen = () => {
//     if (document.fullscreenElement) {
//       if (document.exitFullscreen) {
//         document.exitFullscreen();
//       } else if (document.mozCancelFullScreen) {
//         document.mozCancelFullScreen();
//       } else if (document.webkitExitFullscreen) {
//         document.webkitExitFullscreen();
//       } else if (document.msExitFullscreen) {
//         document.msExitFullscreen();
//       }
//     }
//   };

//   const handleQuestionClick = (index) => {
//     setSelectedQuestionIndex(index);
//   };

//   const isQuestionAnswered = (index) => {
//     const selected = selectedOptions[index];
//     return (
//       selected &&
//       Object.keys(selected).length > 0 &&
//       Object.values(selected).some((v) => v === true)
//     );
//   };

//   const isCurrentQuestion = (index) => {
//     return selectedQuestionIndex === index;
//   };

//   return (
//     <>
//       {!examStarted && <Navbar />}
//       {examData && questions.length > 0 && (
//         <Container className="mt-2" sx={{ mt: { xs: 3, md: 3, lg: 3 } }}>
//           <div className="divider" style={{ marginTop: "2%" }}></div>
//           <h2 className="text-center">{examData?.name}</h2>
//           <div className="divider"></div>

//           {view === "instructions" && (
//             <Instructions
//               examData={examData}
//               setView={handleStartExam}
//               question={questions?.length}
//             />
//           )}

//           {view === "questions" && (
//             <div className="flex flex-col gap-2" style={{ marginTop: "3%" }}>
//               <div className="exam-info-container">
//                 <span className="info-item">
//                   Total Questions: -
//                   <span
//                     style={{
//                       backgroundColor: "green",
//                       color: "#fff",
//                       width: "38px",
//                       borderRadius: "50%",
//                       height: "38px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       padding: "0 10px",
//                       fontSize: "17px",
//                     }}
//                   >
//                     {examData.questions.length}
//                   </span>
//                 </span>
//                 {examData?.negativeMarking !== null &&
//                   examData?.negativeMarking !== 0 && (
//                     <span className="info-item">
//                       Negative Marks: -
//                       <span className="info-badge negative">
//                         {examData.negativeMarking}
//                       </span>
//                     </span>
//                   )}

//                 <span className="info-item">
//                   Time:
//                   <span className="time-display">
//                     {timeLeft.minutes.toString().padStart(2, "0")}:
//                     {timeLeft.seconds.toString().padStart(2, "0")}
//                   </span>
//                 </span>
//               </div>

//               <Box className="flex flex-col" sx={{ mt: 5 }}>
//                 <div
//                   className="flex items-start"
//                   style={{ alignItems: "flex-start" }}
//                 >
//                   <span style={{ marginRight: "10px", fontWeight: "bold" }}>
//                     Q{selectedQuestionIndex + 1}:
//                   </span>
//                   <div style={{ whiteSpace: "pre-line", flex: 1 }}>
//                     {questions[selectedQuestionIndex]?.name
//                       ?.filter((item) => item.type === "text")
//                       .map((item, index) => (
//                         <span
//                           key={index}
//                           dangerouslySetInnerHTML={{
//                             __html: item.content,
//                           }}
//                         />
//                       ))}
//                   </div>
//                 </div>

//                 <div style={{ marginTop: "10px", marginLeft: "30px" }}>
//                   {questions[selectedQuestionIndex]?.name
//                     ?.filter((item) => item.type === "image")
//                     .map((item, index) => (
//                       <div key={index}>
//                         <img
//                           src={item.content}
//                           alt={`Question ${index}`}
//                           style={{ maxWidth: "200px", maxHeight: "200px" }}
//                         />
//                       </div>
//                     ))}
//                 </div>
//               </Box>

//               <div className="flex flex-col gap-4">
//                 {questions[selectedQuestionIndex]?.options.map(
//                   (option, index) => (
//                     <div
//                       className="form-check flex items-start gap-2"
//                       key={index}
//                     >
//                       <input
//                         type={
//                           questions[selectedQuestionIndex]?.questionType ===
//                           "single"
//                             ? "radio"
//                             : "checkbox"
//                         }
//                         name={`question-${selectedQuestionIndex}`}
//                         className="form-check-input"
//                         id={`option-${index}`}
//                         checked={
//                           !!selectedOptions[selectedQuestionIndex]?.[index]
//                         }
//                         onChange={() => handleCheckboxChange(index)}
//                         style={{
//                           cursor: "pointer",
//                           marginTop: "3px",
//                           transform: "scale(1.2)",
//                         }}
//                       />
//                       <label
//                         htmlFor={`option-${index}`}
//                         className="flex flex-col"
//                         style={{
//                           cursor: "pointer",
//                           whiteSpace: "pre-line",
//                           fontSize: "16px",
//                         }}
//                       >
//                         {option.text && (
//                           <span
//                             dangerouslySetInnerHTML={{
//                               __html: option.text,
//                             }}
//                           />
//                         )}
//                         {option.images && option.images.length > 0 && (
//                           <div style={{ marginTop: "10px" }}>
//                             {option.images.map((image, imgIndex) => (
//                               <img
//                                 key={imgIndex}
//                                 src={image}
//                                 alt={`Option ${index} image ${imgIndex}`}
//                                 style={{
//                                   maxWidth: "100px",
//                                   marginTop: "5px",
//                                 }}
//                               />
//                             ))}
//                           </div>
//                         )}
//                       </label>
//                     </div>
//                   ),
//                 )}
//               </div>

//               <div
//                 className="flex gap-2"
//                 style={{ marginBottom: "30px", marginTop: "20px" }}
//               >
//                 {selectedQuestionIndex > 0 && (
//                   <Button
//                     variant="outlined"
//                     className="primary-outlined-btn"
//                     onClick={() => {
//                       setSelectedQuestionIndex(selectedQuestionIndex - 1);
//                     }}
//                   >
//                     Previous
//                   </Button>
//                 )}

//                 {selectedQuestionIndex < questions.length - 1 && (
//                   <Button
//                     variant="contained"
//                     className="primary-contained-btn"
//                     style={{ marginLeft: "12px" }}
//                     onClick={() => {
//                       setSelectedQuestionIndex(selectedQuestionIndex + 1);
//                     }}
//                   >
//                     Next
//                   </Button>
//                 )}

//                 <Button
//                   variant="contained"
//                   color="error"
//                   className="primary-contained-btn"
//                   onClick={showModal}
//                   style={{ marginLeft: "auto" }}
//                 >
//                   Submit Exam
//                 </Button>
//               </div>

//               <Box style={{ display: "flex", justifyContent: "center" }}>
//                 <Container
//                   style={{
//                     display: "flex",
//                     flexDirection: "row",
//                     gap: "5px",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     marginBottom: "5%",
//                     marginTop: "5%",
//                     width: "100%",
//                     height: "auto",
//                     flexWrap: "wrap",
//                     backgroundColor: "#f9f9f9",
//                     padding: "15px",
//                     borderRadius: "8px",
//                   }}
//                 >
//                   {questions.map((_, index) => (
//                     <Box
//                       key={index}
//                       onClick={() => handleQuestionClick(index)}
//                       style={{
//                         backgroundColor: isCurrentQuestion(index)
//                           ? "#ffc93c"
//                           : isQuestionAnswered(index)
//                             ? "#42b883"
//                             : "#455d7a",
//                         fontSize: "17px",
//                         color: "#FFF",
//                         borderRadius: "50%",
//                         width: "40px",
//                         height: "40px",
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         cursor: "pointer",
//                         margin: "5px",
//                         transition: "background-color 0.3s ease",
//                         fontWeight: isCurrentQuestion(index)
//                           ? "bold"
//                           : "normal",
//                         border: isCurrentQuestion(index)
//                           ? "2px solid #ff6b00"
//                           : "none",
//                       }}
//                     >
//                       <ListItemText
//                         primary={`${index + 1}`}
//                         style={{
//                           justifyContent: "center",
//                           alignItems: "center",
//                           display: "flex",
//                         }}
//                       />
//                     </Box>
//                   ))}
//                 </Container>
//               </Box>
//             </div>
//           )}

//           {view === "result" && (
//             <Box>
//               <Typography variant="h6" mt={3}>
//                 <b>Overall Performance Summary</b>
//               </Typography>
//               <Box display="flex" justifyContent="center" mt={2}>
//                 <TableContainer component={Paper}>
//                   <Table>
//                     <TableHead>
//                       <TableRow>
//                         <TableCell
//                           align="center"
//                           colSpan={2}
//                           style={{
//                             background:
//                               result.verdict === "Pass" ? "#4caf50" : "#f44336",
//                             color: "#fff",
//                           }}
//                         >
//                           <h1 style={{ fontWeight: "bold" }}>
//                             RESULT : {result.verdict}
//                           </h1>
//                         </TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       <TableRow>
//                         <TableCell>Total Marks</TableCell>
//                         <TableCell>{result.totalMarks}</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell>Obtained Marks</TableCell>
//                         <TableCell>{result.obtainedMarks}</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell>Percentage</TableCell>
//                         <TableCell>{result.percentage}%</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell>Correct Answers</TableCell>
//                         <TableCell>{result.correctAnswers}</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell>Wrong Answers</TableCell>
//                         <TableCell>{result.wrongAnswers}</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell>Skipped Answers</TableCell>
//                         <TableCell>{result.skippedAnswers || 0}</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell>Passing Marks</TableCell>
//                         <TableCell>{examData.passingMarks}</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell>Attempted</TableCell>
//                         <TableCell>
//                           {(result.correctAnswers || 0) +
//                             (result.wrongAnswers || 0)}
//                         </TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell>Negative Marks</TableCell>
//                         <TableCell>{result.negativeMarks || 0}</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell>Time Taken</TableCell>
//                         <TableCell>
//                           {result.timeTaken
//                             ? `${Math.floor(result.timeTaken / 60)}m ${result.timeTaken % 60}s`
//                             : "N/A"}
//                         </TableCell>
//                       </TableRow>
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Box>
//               <Box className="flex gap-2 mt-2" sx={{ mt: 2, mb: 5 }}>
//                 <Button
//                   variant="contained"
//                   className="primary-contained-btn"
//                   onClick={() => {
//                     setView("review");
//                   }}
//                   sx={{ mb: 2 }}
//                 >
//                   Review Answers
//                 </Button>
//                 <Button
//                   sx={{ mb: 2 }}
//                   variant="outlined"
//                   className="primary-outlined-btn"
//                   onClick={() => {
//                     navigate("/online-exams");
//                     localStorage.removeItem(`timer-${params.id}`);
//                   }}
//                 >
//                   Back to Exams
//                 </Button>
//               </Box>
//             </Box>
//           )}

//           {view === "review" && (
//             <div className="flex flex-col gap-2">
//               {questions?.map((question, index) => {
//                 const selected = selectedOptions[index];
//                 const isAnswered =
//                   selected &&
//                   Object.keys(selected).length > 0 &&
//                   Object.values(selected).some((v) => v === true);

//                 if (isAnswered) {
//                   const selectedOptionsIndexes = Object.keys(selected)
//                     .filter((key) => selected[key])
//                     .map((key) => parseInt(key))
//                     .sort((a, b) => a - b);

//                   const correctOptionsIndices = [
//                     ...question.correctOption,
//                   ].sort((a, b) => a - b);
//                   const isCorrect =
//                     JSON.stringify(selectedOptionsIndexes) ===
//                     JSON.stringify(correctOptionsIndices);

//                   return (
//                     <div
//                       className={`flex flex-col gap-1 p-2`}
//                       key={index}
//                       style={{
//                         border: isCorrect
//                           ? "2px solid #4caf50"
//                           : "2px solid #f44336",
//                         borderRadius: "8px",
//                         marginBottom: "10px",
//                         padding: "15px",
//                         backgroundColor: isCorrect ? "#e8f5e9" : "#ffebee",
//                       }}
//                     >
//                       <h1 className="text-xl">
//                         <div className="flex flex-col items-start">
//                           <div className="flex items-start">
//                             <span
//                               style={{
//                                 marginRight: "10px",
//                                 fontWeight: "bold",
//                               }}
//                             >
//                               Q{index + 1}:
//                             </span>
//                             <div style={{ whiteSpace: "pre-line" }}>
//                               {question.name?.map((item, i) => {
//                                 if (item.type === "text") {
//                                   return (
//                                     <span
//                                       key={i}
//                                       dangerouslySetInnerHTML={{
//                                         __html: item.content,
//                                       }}
//                                     />
//                                   );
//                                 }
//                                 return null;
//                               })}
//                             </div>
//                           </div>
//                           {question.name?.map((item, i) => {
//                             if (item.type === "image") {
//                               return (
//                                 <img
//                                   key={i}
//                                   src={item.content}
//                                   alt={`Question Image ${i}`}
//                                   style={{
//                                     maxWidth: "200px",
//                                     marginTop: "10px",
//                                   }}
//                                 />
//                               );
//                             }
//                             return null;
//                           })}
//                         </div>
//                       </h1>

//                       <div className="text-md" style={{ marginTop: "10px" }}>
//                         <b>Your Answer:</b>
//                         <ul>
//                           {selectedOptionsIndexes?.map((optionIndex, i) => (
//                             <li key={i} style={{ marginTop: "10px" }}>
//                               {question.options[optionIndex]?.text && (
//                                 <span
//                                   dangerouslySetInnerHTML={{
//                                     __html: question.options[optionIndex]?.text,
//                                   }}
//                                 />
//                               )}
//                               {question.options[optionIndex]?.images &&
//                                 Array.isArray(
//                                   question.options[optionIndex]?.images,
//                                 ) &&
//                                 question.options[optionIndex]?.images.map(
//                                   (image, j) => (
//                                     <img
//                                       key={j}
//                                       src={image}
//                                       alt={`Submitted Option ${i} Image ${j}`}
//                                       style={{
//                                         maxWidth: "100px",
//                                         marginTop: "5px",
//                                       }}
//                                     />
//                                   ),
//                                 )}
//                             </li>
//                           ))}
//                         </ul>
//                       </div>

//                       <div className="text-md" style={{ marginTop: "10px" }}>
//                         <b style={{ color: "#4caf50" }}>Correct Answer:</b>
//                         <ul>
//                           {correctOptionsIndices?.map((optionIndex, i) => (
//                             <li key={i} style={{ marginTop: "10px" }}>
//                               {question.options[optionIndex]?.text && (
//                                 <span
//                                   dangerouslySetInnerHTML={{
//                                     __html: question.options[optionIndex]?.text,
//                                   }}
//                                 />
//                               )}
//                               {question.options[optionIndex]?.images &&
//                                 Array.isArray(
//                                   question.options[optionIndex]?.images,
//                                 ) &&
//                                 question.options[optionIndex]?.images.map(
//                                   (image, j) => (
//                                     <img
//                                       key={j}
//                                       src={image}
//                                       alt={`Correct Option ${i} Image ${j}`}
//                                       style={{
//                                         maxWidth: "100px",
//                                         marginTop: "5px",
//                                       }}
//                                     />
//                                   ),
//                                 )}
//                             </li>
//                           ))}
//                         </ul>
//                       </div>

//                       <div className="text-sm" style={{ marginTop: "10px" }}>
//                         <b>Marks Awarded:</b> {isCorrect ? question.marks : 0}
//                       </div>
//                     </div>
//                   );
//                 }
//                 return (
//                   <div
//                     key={index}
//                     style={{
//                       border: "2px solid #ff9800",
//                       borderRadius: "8px",
//                       marginBottom: "10px",
//                       padding: "15px",
//                       backgroundColor: "#fff3e0",
//                     }}
//                   >
//                     {/* Question */}
//                     <div style={{ marginBottom: "10px" }}>
//                       <strong>Q{index + 1}:</strong>{" "}
//                       <span
//                         dangerouslySetInnerHTML={{
//                           __html: question.name
//                             ?.filter((item) => item.type === "text")
//                             ?.map((item) => item.content)
//                             ?.join(" "),
//                         }}
//                       />
//                     </div>

//                     {/* Status */}
//                     <p style={{ color: "#f57c00", fontWeight: "bold" }}>
//                       Not attempted
//                     </p>

//                     {/* All Options */}
//                     <div style={{ marginTop: "10px", marginBottom: "10px" }}>
//                       {question.options?.map((option, optionIndex) => {
//                         const optionLabel = String.fromCharCode(
//                           65 + optionIndex,
//                         );

//                         return (
//                           <div
//                             key={optionIndex}
//                             style={{
//                               marginBottom: "6px",
//                               paddingLeft: "10px",
//                               display: "flex",
//                             }}
//                           >
//                             <strong>{optionLabel}. </strong>

//                             <span
//                               style={{ marginLeft: "2px" }}
//                               dangerouslySetInnerHTML={{
//                                 __html: option.text,
//                               }}
//                             />
//                           </div>
//                         );
//                       })}
//                     </div>

//                     {/* Correct Answer */}
//                     <p style={{ marginTop: "10px" }}>
//                       <b>Correct Answer:</b>{" "}
//                       {question.correctOption
//                         ?.map((opt) =>
//                           question.options[opt]?.text
//                             ?.replace(/<[^>]*>/g, "")
//                             ?.trim(),
//                         )
//                         .join(", ")}
//                     </p>
//                   </div>
//                 );
//               })}

//               <Box className="flex justify-center gap-2" sx={{ mb: 10, mt: 3 }}>
//                 <Button
//                   variant="contained"
//                   className="primary-contained-btn"
//                   onClick={() => {
//                     setView("result");
//                   }}
//                 >
//                   Back to Result
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   className="primary-outlined-btn"
//                   onClick={() => {
//                     navigate("/online-exams");
//                     localStorage.removeItem(`timer-${params.id}`);
//                   }}
//                 >
//                   Close
//                 </Button>
//               </Box>
//             </div>
//           )}
//         </Container>
//       )}

//       <Modal
//         title="Confirm Submission"
//         open={isModalVisible}
//         onOk={handleOk}
//         onCancel={handleCancel}
//         okText="Yes, Submit"
//         cancelText="No, Go Back"
//       >
//         <p>Are you sure you want to submit this exam?</p>
//         <p style={{ color: "red", marginTop: "10px" }}>
//           Note: You cannot change your answers after submission.
//         </p>
//       </Modal>
//     </>
//   );
// };

// export default WriteExam;

/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import useDisableCopy from "../Components/useDisableCopy";
import Instructions from "../exams/Instructions";
import { message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Alert,
} from "@mui/material";
import axios from "../axiosInstance";
import { Box } from "@mui/material";
import { ListItemText } from "@mui/material";
import "./WriteExam.css";
import { Modal } from "antd";
import moment from "moment";

const WriteExam = () => {
  useDisableCopy();
  const studentData = JSON.parse(localStorage.getItem("verifiedStudent"));
  const params = useParams();
  const [examData, setExamData] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [result, setResult] = useState({});
  const navigate = useNavigate();
  const [view, setView] = useState("instructions");
  const [timeLeft, setTimeLeft] = useState({ minutes: 0, seconds: 0 });
  const [timeUp, setTimeUp] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [examStarted, setExamStarted] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null); // Track submission status
  const [resultNotAvailable, setResultNotAvailable] = useState(false);

  // Handle the modal visibility
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    clearInterval(intervalId);
    setTimeUp(true);
    localStorage.removeItem(`timer-${params.id}`);
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // Function to check if result should be shown now
  const isResultAvailable = (exam) => {
    if (!exam) return false;
    
    // If no resultDate/resultTime set, result is available immediately
    if (!exam.resultDate || !exam.resultTime) {
      return true;
    }
    
    // Parse result date and time
    const [day, month, year] = exam.resultDate.split("/");
    const resultDateTime = moment(
      `${year}-${month}-${day}T${exam.resultTime}:00`
    );
    const currentDateTime = moment();
    
    return currentDateTime.isSameOrAfter(resultDateTime);
  };

  // Format result date for display
  const formatResultDate = (dateStr, timeStr) => {
    if (!dateStr) return "Not scheduled";
    
    const [day, month, year] = dateStr.split("/");
    const date = moment(`${year}-${month}-${day}`);
    
    const formattedDate = date.format("DD MMMM YYYY");
    
    if (timeStr) {
      const formattedTime = moment(timeStr, "HH:mm").format("h:mm A");
      return `${formattedDate} at ${formattedTime}`;
    }
    
    return formattedDate;
  };

  // Transform API question data to component format
  const transformQuestions = (apiQuestions) => {
    return apiQuestions.map((q) => {
      console.log("Question Data:", q);
      console.log("Options:", q.options);
      console.log("Correct Options:", q.correctOption);
      // Extract text and images from questionText
      const questionContent = [];
      if (q.questionText) {
        questionContent.push({
          type: "text",
          content: q.questionText,
        });
      }
      if (q.questionImage && q.questionImage !== "") {
        questionContent.push({
          type: "image",
          content: q.questionImage,
        });
      }

      // Transform options
      const options = q.options.map((opt, idx) => ({
        text: opt.text || "",
        images: opt.image && opt.image !== "" ? [opt.image] : [],
      }));

      const correctOptionIndices = (q.correctOptions || []).map((opt) =>
        typeof opt === "object" ? opt.optionIndex : opt,
      );

      return {
        _id: q._id,
        name: questionContent,
        options: options,
        correctOption: correctOptionIndices,
        correctOptionTexts: q.correctOptions,
        questionType: q.questionType,
        marks: q.marks || 1,
      };
    });
  };

  // Fetch exam data
  const getExamData = async () => {
    try {
      const response = await axios.get(`/api/v1/exam/attempt/${params?.id}`);

      if (response.data.success && response.data.data) {
        const apiData = response.data.data;

        // Transform questions to expected format
        const transformedQuestions = transformQuestions(
          apiData.questions || [],
        );

        setQuestions(transformedQuestions);
        setExamData({
          ...apiData,
          questions: transformedQuestions,
          totalMarks: apiData.totalMarks,
          duration: apiData.duration,
          passingMarks: apiData.passingMarks,
          negativeMarking: apiData.negativeMarking,
          name: apiData.name,
          subject: apiData.subject,
          class: apiData.class,
          examSet: apiData.examSet || "Set 1",
          category: apiData.subject || "General",
          instituteCourseId: apiData.class || "",
          resultDate: apiData.resultDate,
          resultTime: apiData.resultTime,
        });

        const savedTime = JSON.parse(
          localStorage.getItem(`timer-${params.id}`),
        );
        if (savedTime) {
          setTimeLeft(savedTime);
        } else {
          setTimeLeft({
            minutes: Math.floor(apiData.duration || 0),
            seconds: 0,
          });
        }

        // Initialize selectedOptions array
        setSelectedOptions(new Array(transformedQuestions.length).fill({}));
      }
    } catch (error) {
      message.error(
        error.response?.data?.message || "Failed to fetch exam data",
      );
    }
  };

  // Function to handle checkbox changes based on user selection
  const handleCheckboxChange = (optionIndex) => {
    const currentQuestion = questions[selectedQuestionIndex];
    const isSingleSelect =
      currentQuestion?.questionType === "single" ||
      currentQuestion?.correctOption?.length === 1;

    setSelectedOptions((prev) => {
      const updated = [...prev];
      const currentSelected = updated[selectedQuestionIndex] || {};

      if (isSingleSelect) {
        const newSelected = {};
        newSelected[optionIndex] = !currentSelected[optionIndex];
        updated[selectedQuestionIndex] = newSelected;
      } else {
        updated[selectedQuestionIndex] = {
          ...currentSelected,
          [optionIndex]: !currentSelected[optionIndex],
        };
      }

      return updated;
    });
  };

  // Calculate time taken
  const calculateTimeTaken = () => {
    if (startTime) {
      const endTime = new Date();
      const timeDiff = Math.floor((endTime - startTime) / 1000);
      return timeDiff;
    }
    return 0;
  };

  // Prepare answers array for API
  const prepareAnswersArray = () => {
    const answers = [];

    questions.forEach((question, index) => {
      const selected = selectedOptions[index];

      let selectedOptionsList = [];

      if (selected) {
        selectedOptionsList = Object.keys(selected)
          .filter((key) => selected[key])
          .map((key) => Number(key));
      }

      answers.push({
        questionId: question._id,
        selectedOptions: selectedOptionsList,
      });
    });

    return answers;
  };

  // Calculate Exam Result and Submit to API
  const calculateResult = async () => {
    try {
      const timeTaken = calculateTimeTaken();
      const answers = prepareAnswersArray();

      const studentClass = examData?.class || "Not Specified";
      const studentName =
        studentData?.studentName || studentData?.name || "Student";

      const requestBody = {
        examId: params?.id,
        studentId: studentData?._id,
        studentName: studentName,
        studentClass: studentClass,
        timeTaken: timeTaken,
        answers: answers,
      };

      const response = await axios.post(`/api/v1/report/submit`, requestBody);

      if (response.data.success) {
        setSubmissionStatus("submitted");
        
        // Check if result is available now or later
        if (isResultAvailable(examData)) {
          setResult({
            verdict: response.data.data.verdict,
            totalMarks: response.data.data.totalMarks,
            obtainedMarks: response.data.data.obtainedMarks,
            correctAnswers: response.data.data.correctAnswers,
            wrongAnswers: response.data.data.wrongAnswers,
            skippedAnswers: response.data.data.skippedAnswers,
            negativeMarks: response.data.data.negativeMarks,
            percentage: response.data.data.percentage,
            timeTaken: response.data.data.timeTaken,
          });
          setView("result");
          message.success(response.data.message);
        } else {
          // Result not available yet due to result declaration date
          setResultNotAvailable(true);
          setView("submission_confirmation");
          message.info(
            `Exam submitted successfully! Result will be available on ${formatResultDate(
              examData.resultDate,
              examData.resultTime
            )}`
          );
        }
      } else {
        message.error(response.data.message);
        calculateLocalResult();
      }
    } catch (error) {
      console.error("Submit exam error:", error);
      message.error(error.response?.data?.message || "Failed to submit exam");
      calculateLocalResult();
    }
  };

  // Local calculation
  const calculateLocalResult = () => {
    let correctAnswers = 0;
    let wrongAnswers = 0;
    let skippedAnswers = 0;
    let obtainedMarks = 0;
    let negativeMarksTotal = 0;
    const negativeMarking = examData?.negativeMarking || 0;

    questions.forEach((question, index) => {
      const selected = selectedOptions[index];
      const questionMarks = question.marks || 1;

      if (
        !selected ||
        Object.keys(selected).length === 0 ||
        Object.values(selected).every((v) => v === false)
      ) {
        skippedAnswers++;
        return;
      }

      const selectedOptionsIndexes = Object.keys(selected)
        .filter((key) => selected[key])
        .map((key) => parseInt(key))
        .sort((a, b) => a - b);

      const correctOptionsIndices = [...question.correctOption].sort(
        (a, b) => a - b,
      );

      const isCorrect =
        JSON.stringify(selectedOptionsIndexes) ===
        JSON.stringify(correctOptionsIndices);

      if (isCorrect) {
        correctAnswers++;
        obtainedMarks += questionMarks;
      } else {
        wrongAnswers++;
        if (negativeMarking > 0) {
          const deduction = negativeMarking;
          negativeMarksTotal += deduction;
          obtainedMarks -= deduction;
        }
      }
    });

    obtainedMarks = Math.max(0, obtainedMarks);
    const percentage = (obtainedMarks / examData.totalMarks) * 100;
    let verdict = "Fail";
    if (obtainedMarks >= examData.passingMarks) {
      verdict = "Pass";
    }

    // Check if result should be shown
    if (isResultAvailable(examData)) {
      setResult({
        correctAnswers,
        wrongAnswers,
        skippedAnswers,
        verdict,
        totalMarks: examData.totalMarks,
        obtainedMarks: obtainedMarks.toFixed(2),
        percentage: percentage.toFixed(2),
        negativeMarks: negativeMarksTotal,
        timeTaken: calculateTimeTaken(),
      });
      setView("result");
    } else {
      setResultNotAvailable(true);
      setView("submission_confirmation");
      message.info(
        `Exam submitted successfully! Result will be available on ${formatResultDate(
          examData.resultDate,
          examData.resultTime
        )}`
      );
    }
  };

  // Start Timer Function
  const startTimer = () => {
    let totalSeconds = timeLeft.minutes * 60 + timeLeft.seconds;
    const intervalId = setInterval(() => {
      if (totalSeconds > 0) {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        setTimeLeft({ minutes, seconds });
        localStorage.setItem(
          `timer-${params.id}`,
          JSON.stringify({ minutes, seconds }),
        );
        totalSeconds--;
      } else {
        clearInterval(intervalId);
        setTimeUp(true);
      }
    }, 1000);
    setIntervalId(intervalId);
  };

  useEffect(() => {
    if (timeUp && view === "questions") {
      clearInterval(intervalId);
      calculateResult();
      localStorage.removeItem(`timer-${params.id}`);
    }
  }, [timeUp]);

  useEffect(() => {
    if (params.id) {
      getExamData();
    }
  }, [params.id]);

  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
      if (view !== "result" && view !== "submission_confirmation") {
        localStorage.removeItem("selectedOptions");
        localStorage.removeItem("selectedQuestionIndex");
        localStorage.removeItem("timeLeft");
        localStorage.removeItem(`timer-${params.id}`);
        exitFullScreen();
        setExamStarted(false);
      }
    };
  }, [params.id, intervalId, view]);

  const requestFullScreen = (element) => {
    if (element?.requestFullscreen) {
      element?.requestFullscreen();
    } else if (element?.mozRequestFullScreen) {
      element?.mozRequestFullScreen();
    } else if (element?.webkitRequestFullscreen) {
      element?.webkitRequestFullscreen();
    } else if (element?.msRequestFullscreen) {
      element?.msRequestFullscreen();
    }
  };

  const handleStartExam = () => {
    setView("questions");
    requestFullScreen(document?.documentElement);
    setStartTime(new Date());
    startTimer();
    setExamStarted(true);
  };

  const exitFullScreen = () => {
    if (document.fullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  const handleQuestionClick = (index) => {
    setSelectedQuestionIndex(index);
  };

  const isQuestionAnswered = (index) => {
    const selected = selectedOptions[index];
    return (
      selected &&
      Object.keys(selected).length > 0 &&
      Object.values(selected).some((v) => v === true)
    );
  };

  const isCurrentQuestion = (index) => {
    return selectedQuestionIndex === index;
  };

  return (
    <>
      {!examStarted && <Navbar />}
      {examData && questions.length > 0 && (
        <Container className="mt-2" sx={{ mt: { xs: 3, md: 3, lg: 3 } }}>
          <div className="divider" style={{ marginTop: "2%" }}></div>
          <h2 className="text-center">{examData?.name}</h2>
          <div className="divider"></div>

          {view === "instructions" && (
            <Instructions
              examData={examData}
              setView={handleStartExam}
              question={questions?.length}
            />
          )}

          {view === "questions" && (
            <div className="flex flex-col gap-2" style={{ marginTop: "3%" }}>
              <div className="exam-info-container">
                <span className="info-item">
                  Total Questions: -
                  <span
                    style={{
                      backgroundColor: "green",
                      color: "#fff",
                      width: "38px",
                      borderRadius: "50%",
                      height: "38px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0 10px",
                      fontSize: "17px",
                    }}
                  >
                    {examData.questions.length}
                  </span>
                </span>
                {examData?.negativeMarking !== null &&
                  examData?.negativeMarking !== 0 && (
                    <span className="info-item">
                      Negative Marks: -
                      <span className="info-badge negative">
                        {examData.negativeMarking}
                      </span>
                    </span>
                  )}

                <span className="info-item">
                  Time:
                  <span className="time-display">
                    {timeLeft.minutes.toString().padStart(2, "0")}:
                    {timeLeft.seconds.toString().padStart(2, "0")}
                  </span>
                </span>
              </div>

              <Box className="flex flex-col" sx={{ mt: 5 }}>
                <div
                  className="flex items-start"
                  style={{ alignItems: "flex-start" }}
                >
                  <span style={{ marginRight: "10px", fontWeight: "bold" }}>
                    Q{selectedQuestionIndex + 1}:
                  </span>
                  <div style={{ whiteSpace: "pre-line", flex: 1 }}>
                    {questions[selectedQuestionIndex]?.name
                      ?.filter((item) => item.type === "text")
                      .map((item, index) => (
                        <span
                          key={index}
                          dangerouslySetInnerHTML={{
                            __html: item.content,
                          }}
                        />
                      ))}
                  </div>
                </div>

                <div style={{ marginTop: "10px", marginLeft: "30px" }}>
                  {questions[selectedQuestionIndex]?.name
                    ?.filter((item) => item.type === "image")
                    .map((item, index) => (
                      <div key={index}>
                        <img
                          src={item.content}
                          alt={`Question ${index}`}
                          style={{ maxWidth: "200px", maxHeight: "200px" }}
                        />
                      </div>
                    ))}
                </div>
              </Box>

              <div className="flex flex-col gap-4">
                {questions[selectedQuestionIndex]?.options.map(
                  (option, index) => (
                    <div
                      className="form-check flex items-start gap-2"
                      key={index}
                    >
                      <input
                        type={
                          questions[selectedQuestionIndex]?.questionType ===
                          "single"
                            ? "radio"
                            : "checkbox"
                        }
                        name={`question-${selectedQuestionIndex}`}
                        className="form-check-input"
                        id={`option-${index}`}
                        checked={
                          !!selectedOptions[selectedQuestionIndex]?.[index]
                        }
                        onChange={() => handleCheckboxChange(index)}
                        style={{
                          cursor: "pointer",
                          marginTop: "3px",
                          transform: "scale(1.2)",
                        }}
                      />
                      <label
                        htmlFor={`option-${index}`}
                        className="flex flex-col"
                        style={{
                          cursor: "pointer",
                          whiteSpace: "pre-line",
                          fontSize: "16px",
                        }}
                      >
                        {option.text && (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: option.text,
                            }}
                          />
                        )}
                        {option.images && option.images.length > 0 && (
                          <div style={{ marginTop: "10px" }}>
                            {option.images.map((image, imgIndex) => (
                              <img
                                key={imgIndex}
                                src={image}
                                alt={`Option ${index} image ${imgIndex}`}
                                style={{
                                  maxWidth: "100px",
                                  marginTop: "5px",
                                }}
                              />
                            ))}
                          </div>
                        )}
                      </label>
                    </div>
                  ),
                )}
              </div>

              <div
                className="flex gap-2"
                style={{ marginBottom: "30px", marginTop: "20px" }}
              >
                {selectedQuestionIndex > 0 && (
                  <Button
                    variant="outlined"
                    className="primary-outlined-btn"
                    onClick={() => {
                      setSelectedQuestionIndex(selectedQuestionIndex - 1);
                    }}
                  >
                    Previous
                  </Button>
                )}

                {selectedQuestionIndex < questions.length - 1 && (
                  <Button
                    variant="contained"
                    className="primary-contained-btn"
                    style={{ marginLeft: "12px" }}
                    onClick={() => {
                      setSelectedQuestionIndex(selectedQuestionIndex + 1);
                    }}
                  >
                    Next
                  </Button>
                )}

                <Button
                  variant="contained"
                  color="error"
                  className="primary-contained-btn"
                  onClick={showModal}
                  style={{ marginLeft: "auto" }}
                >
                  Submit Exam
                </Button>
              </div>

              <Box style={{ display: "flex", justifyContent: "center" }}>
                <Container
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "5px",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "5%",
                    marginTop: "5%",
                    width: "100%",
                    height: "auto",
                    flexWrap: "wrap",
                    backgroundColor: "#f9f9f9",
                    padding: "15px",
                    borderRadius: "8px",
                  }}
                >
                  {questions.map((_, index) => (
                    <Box
                      key={index}
                      onClick={() => handleQuestionClick(index)}
                      style={{
                        backgroundColor: isCurrentQuestion(index)
                          ? "#ffc93c"
                          : isQuestionAnswered(index)
                            ? "#42b883"
                            : "#455d7a",
                        fontSize: "17px",
                        color: "#FFF",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        margin: "5px",
                        transition: "background-color 0.3s ease",
                        fontWeight: isCurrentQuestion(index)
                          ? "bold"
                          : "normal",
                        border: isCurrentQuestion(index)
                          ? "2px solid #ff6b00"
                          : "none",
                      }}
                    >
                      <ListItemText
                        primary={`${index + 1}`}
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                        }}
                      />
                    </Box>
                  ))}
                </Container>
              </Box>
            </div>
          )}

          {/* Submission Confirmation View - When result not available yet */}
          {view === "submission_confirmation" && resultNotAvailable && (
            <Box sx={{ textAlign: "center", py: 5 }}>
              <Alert
                severity="info"
                sx={{
                  mb: 4,
                  p: 3,
                  borderRadius: 2,
                  bgcolor: "#e3f2fd",
                }}
              >
                <Typography variant="h6" gutterBottom>
                  ✓ Exam Submitted Successfully!
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                  Your exam has been submitted. The results will be available on:
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    mt: 2,
                    color: "#065A79",
                    fontWeight: "bold",
                  }}
                >
                  {formatResultDate(examData?.resultDate, examData?.resultTime)}
                </Typography>
                <Typography variant="body2" sx={{ mt: 3, color: "#666" }}>
                  Please check back after the result declaration date to view your score.
                </Typography>
              </Alert>

              <Box className="flex gap-2 justify-center" sx={{ mt: 2 }}>
                <Button
                  variant="contained"
                  className="primary-contained-btn"
                  onClick={() => {
                    navigate("/online-exams");
                    localStorage.removeItem(`timer-${params.id}`);
                  }}
                >
                  Back to Exams
                </Button>
              </Box>
            </Box>
          )}

          {view === "result" && (
            <Box>
              <Typography variant="h6" mt={3}>
                <b>Overall Performance Summary</b>
              </Typography>
              <Box display="flex" justifyContent="center" mt={2}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={2}
                          style={{
                            background:
                              result.verdict === "Pass" ? "#4caf50" : "#f44336",
                            color: "#fff",
                          }}
                        >
                          <h1 style={{ fontWeight: "bold" }}>
                            RESULT : {result.verdict}
                          </h1>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>Total Marks</TableCell>
                        <TableCell>{result.totalMarks}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Obtained Marks</TableCell>
                        <TableCell>{result.obtainedMarks}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Percentage</TableCell>
                        <TableCell>{result.percentage}%</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Correct Answers</TableCell>
                        <TableCell>{result.correctAnswers}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Wrong Answers</TableCell>
                        <TableCell>{result.wrongAnswers}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Skipped Answers</TableCell>
                        <TableCell>{result.skippedAnswers || 0}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Passing Marks</TableCell>
                        <TableCell>{examData.passingMarks}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Attempted</TableCell>
                        <TableCell>
                          {(result.correctAnswers || 0) +
                            (result.wrongAnswers || 0)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Negative Marks</TableCell>
                        <TableCell>{result.negativeMarks || 0}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Time Taken</TableCell>
                        <TableCell>
                          {result.timeTaken
                            ? `${Math.floor(result.timeTaken / 60)}m ${result.timeTaken % 60}s`
                            : "N/A"}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <Box className="flex gap-2 mt-2" sx={{ mt: 2, mb: 5 }}>
                <Button
                  variant="contained"
                  className="primary-contained-btn"
                  onClick={() => {
                    setView("review");
                  }}
                  sx={{ mb: 2 }}
                >
                  Review Answers
                </Button>
                <Button
                  sx={{ mb: 2 }}
                  variant="outlined"
                  className="primary-outlined-btn"
                  onClick={() => {
                    navigate("/online-exams");
                    localStorage.removeItem(`timer-${params.id}`);
                  }}
                >
                  Back to Exams
                </Button>
              </Box>
            </Box>
          )}

          {view === "review" && (
            <div className="flex flex-col gap-2">
              {questions?.map((question, index) => {
                const selected = selectedOptions[index];
                const isAnswered =
                  selected &&
                  Object.keys(selected).length > 0 &&
                  Object.values(selected).some((v) => v === true);

                if (isAnswered) {
                  const selectedOptionsIndexes = Object.keys(selected)
                    .filter((key) => selected[key])
                    .map((key) => parseInt(key))
                    .sort((a, b) => a - b);

                  const correctOptionsIndices = [
                    ...question.correctOption,
                  ].sort((a, b) => a - b);
                  const isCorrect =
                    JSON.stringify(selectedOptionsIndexes) ===
                    JSON.stringify(correctOptionsIndices);

                  return (
                    <div
                      className={`flex flex-col gap-1 p-2`}
                      key={index}
                      style={{
                        border: isCorrect
                          ? "2px solid #4caf50"
                          : "2px solid #f44336",
                        borderRadius: "8px",
                        marginBottom: "10px",
                        padding: "15px",
                        backgroundColor: isCorrect ? "#e8f5e9" : "#ffebee",
                      }}
                    >
                      <h1 className="text-xl">
                        <div className="flex flex-col items-start">
                          <div className="flex items-start">
                            <span
                              style={{
                                marginRight: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              Q{index + 1}:
                            </span>
                            <div style={{ whiteSpace: "pre-line" }}>
                              {question.name?.map((item, i) => {
                                if (item.type === "text") {
                                  return (
                                    <span
                                      key={i}
                                      dangerouslySetInnerHTML={{
                                        __html: item.content,
                                      }}
                                    />
                                  );
                                }
                                return null;
                              })}
                            </div>
                          </div>
                          {question.name?.map((item, i) => {
                            if (item.type === "image") {
                              return (
                                <img
                                  key={i}
                                  src={item.content}
                                  alt={`Question Image ${i}`}
                                  style={{
                                    maxWidth: "200px",
                                    marginTop: "10px",
                                  }}
                                />
                              );
                            }
                            return null;
                          })}
                        </div>
                      </h1>

                      <div className="text-md" style={{ marginTop: "10px" }}>
                        <b>Your Answer:</b>
                        <ul>
                          {selectedOptionsIndexes?.map((optionIndex, i) => (
                            <li key={i} style={{ marginTop: "10px" }}>
                              {question.options[optionIndex]?.text && (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: question.options[optionIndex]?.text,
                                  }}
                                />
                              )}
                              {question.options[optionIndex]?.images &&
                                Array.isArray(
                                  question.options[optionIndex]?.images,
                                ) &&
                                question.options[optionIndex]?.images.map(
                                  (image, j) => (
                                    <img
                                      key={j}
                                      src={image}
                                      alt={`Submitted Option ${i} Image ${j}`}
                                      style={{
                                        maxWidth: "100px",
                                        marginTop: "5px",
                                      }}
                                    />
                                  ),
                                )}
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="text-md" style={{ marginTop: "10px" }}>
                        <b style={{ color: "#4caf50" }}>Correct Answer:</b>
                        <ul>
                          {correctOptionsIndices?.map((optionIndex, i) => (
                            <li key={i} style={{ marginTop: "10px" }}>
                              {question.options[optionIndex]?.text && (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: question.options[optionIndex]?.text,
                                  }}
                                />
                              )}
                              {question.options[optionIndex]?.images &&
                                Array.isArray(
                                  question.options[optionIndex]?.images,
                                ) &&
                                question.options[optionIndex]?.images.map(
                                  (image, j) => (
                                    <img
                                      key={j}
                                      src={image}
                                      alt={`Correct Option ${i} Image ${j}`}
                                      style={{
                                        maxWidth: "100px",
                                        marginTop: "5px",
                                      }}
                                    />
                                  ),
                                )}
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="text-sm" style={{ marginTop: "10px" }}>
                        <b>Marks Awarded:</b> {isCorrect ? question.marks : 0}
                      </div>
                    </div>
                  );
                }
                return (
                  <div
                    key={index}
                    style={{
                      border: "2px solid #ff9800",
                      borderRadius: "8px",
                      marginBottom: "10px",
                      padding: "15px",
                      backgroundColor: "#fff3e0",
                    }}
                  >
                    <div style={{ marginBottom: "10px" }}>
                      <strong>Q{index + 1}:</strong>{" "}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: question.name
                            ?.filter((item) => item.type === "text")
                            ?.map((item) => item.content)
                            ?.join(" "),
                        }}
                      />
                    </div>

                    <p style={{ color: "#f57c00", fontWeight: "bold" }}>
                      Not attempted
                    </p>

                    <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                      {question.options?.map((option, optionIndex) => {
                        const optionLabel = String.fromCharCode(
                          65 + optionIndex,
                        );

                        return (
                          <div
                            key={optionIndex}
                            style={{
                              marginBottom: "6px",
                              paddingLeft: "10px",
                              display: "flex",
                            }}
                          >
                            <strong>{optionLabel}. </strong>

                            <span
                              style={{ marginLeft: "2px" }}
                              dangerouslySetInnerHTML={{
                                __html: option.text,
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>

                    <p style={{ marginTop: "10px" }}>
                      <b>Correct Answer:</b>{" "}
                      {question.correctOption
                        ?.map((opt) =>
                          question.options[opt]?.text
                            ?.replace(/<[^>]*>/g, "")
                            ?.trim(),
                        )
                        .join(", ")}
                    </p>
                  </div>
                );
              })}

              <Box className="flex justify-center gap-2" sx={{ mb: 10, mt: 3 }}>
                <Button
                  variant="contained"
                  className="primary-contained-btn"
                  onClick={() => {
                    setView("result");
                  }}
                >
                  Back to Result
                </Button>
                <Button
                  variant="outlined"
                  className="primary-outlined-btn"
                  onClick={() => {
                    navigate("/online-exams");
                    localStorage.removeItem(`timer-${params.id}`);
                  }}
                >
                  Close
                </Button>
              </Box>
            </div>
          )}
        </Container>
      )}

      <Modal
        title="Confirm Submission"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Yes, Submit"
        cancelText="No, Go Back"
      >
        <p>Are you sure you want to submit this exam?</p>
        <p style={{ color: "red", marginTop: "10px" }}>
          Note: You cannot change your answers after submission.
        </p>
      </Modal>
    </>
  );
};

export default WriteExam;